module.exports = __webpack_public_path__ + "img/iPhone 11 - Pro.e7a29937.png";